import type { ILocalStorageData } from '../interfaces/local-storage';

const storageId = 'gqa';

export const LocalStoreHandler = {
  update: (data: Partial<ILocalStorageData>): void => {
    const existingData = localStorage.getItem(storageId);
    let newData = {};
    if (existingData) {
      newData = {
        ...JSON.parse(existingData),
        ...data,
      };
    } else {
      newData = data;
    }

    localStorage.setItem(storageId, JSON.stringify(newData));
  },
  get: (): any => {
    const data = localStorage.getItem(storageId);
    return data ? JSON.parse(data) : null;
  },
  remove: (key: keyof ILocalStorageData): void => {
    const existingData = localStorage.getItem(storageId);

    if (existingData) {
      let newData = JSON.parse(existingData);

      if (newData[key]) delete newData[key];

      localStorage.setItem(storageId, JSON.stringify(newData));
    }
  },
};
